<template>
<div>
    <HeaderContent header="จัดการรูปภาพหน้าเว็บไซต์" :img_header="header_image" link_back="content" />
    <MenuContentManageImage />
    <ContentManageBannerList />
</div>
</template>

<script>
import HeaderImage from '@/assets/picture.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import MenuContentManageImage from '@/components/menuadmin/content/contentmanageimage/MenuContentManageImage.vue'
import ContentManageBannerList from '@/components/menuadmin/content/contentmanageimage/ContentManageBannerList.vue'

export default {
    name: 'contentManageBanner',
    components: {
        HeaderContent,
        MenuContentManageImage,
        ContentManageBannerList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
